'use client';

import Link from 'next/link';
import { GreenhouseJob } from '@/libs/greenhouse/greenhouse';
import { getJobTeam, getJobUrl } from '@/libs/greenhouse/greenhouse-functions';
import SaveJobButton from '../shared/SaveJobButton/SaveJobButton';

const JobCard = ({ job }: { job: GreenhouseJob }) => {
  return (
    <div className="w-full p-6 md:p-10 rounded-[20px] bg-primary text-flush relative hover:shadow-2xl transition-shadow">
      <div className="flex items-center justify-between gap-4 mb-6">
        <ul className="flex items-center gap-10 font-bold text-base">
          <li>{getJobTeam(job)}</li>
          <li>{job.location.name}</li>
        </ul>
        <SaveJobButton job={job} />
      </div>
      <Link
        href={getJobUrl(job)}
        className="font-bold text-heading-md mt-6 after:absolute after:top-0 after:left-0 after:bottom-0 after:right-0 after:z-1">
        {job.title}
      </Link>
    </div>
  );
};

export default JobCard;
